<template>
    <div class="stalking-panel">
        <div class="stalking-panel__container container">
            <div class="stalking-panel__left">
                <template v-if="!isPreloader">
                    <span :class="{ sale: isValidOldPrice }"
                        >{{ $t('globalTextAttributeCurrencySpecific') }} {{ handledPrice }}</span
                    >
                    <del v-if="oldPrice && isValidOldPrice"
                        >{{ $t('globalTextAttributeCurrencySpecific') }} {{ handledOldPrice }}</del
                    >
                </template>
            </div>
            <div class="stalking-panel__right">
                <!-- DESKTOP -->
                <client-only>
                    <div class="stalking-panel__right__btns">
                        <MyActionBtn
                            v-if="isActive"
                            type="default"
                            :disabled="isPreloader || !isAvailable"
                            :size="btnsSize"
                            theme="default"
                            btnType="button"
                            :btnText="$t('stalkingPanelButtonsAddToCart')"
                            :icon="'cartIcon'"
                            @click="triggerActionAddToCart"
                        />
                        <MyActionBtn
                            btnType="button"
                            type="default"
                            :size="btnsSize"
                            :theme="'dark'"
                            :btnText="$t('stalkingPanelButtonsAskSpecialist')"
                            :icon="'arrowRightIcon'"
                            @click="openModalAskSpecialist()"
                        />
                        <MyActionBtn
                            :class="{ liked: isInFavorites }"
                            btnType="button"
                            type="icon"
                            :size="btnsSize"
                            :theme="'transparent-border'"
                            :icon="'likeIcon'"
                            :disabled="isPreloader"
                            @click="triggerActionFavorites"
                        />
                    </div>
                </client-only>
                <!-- MOBILE -->
                <div class="stalking-panel__right__btns --mobile">
                    <MyActionBtn
                        :class="{ liked: isInFavorites }"
                        btnType="button"
                        type="icon"
                        :size="'small'"
                        :theme="'transparent-border'"
                        :icon="'likeIcon'"
                        :disabled="isPreloader"
                        @click="triggerActionFavorites"
                    />
                    <MyActionBtn
                        v-if="isActive"
                        type="icon"
                        :size="'small'"
                        theme="default"
                        btnType="button"
                        :icon="'cartIcon'"
                        :disabled="isPreloader || !isAvailable"
                        @click="triggerActionAddToCart"
                    />
                    <MyActionBtn
                        btnType="button"
                        type="icon"
                        :size="'small'"
                        :theme="'dark'"
                        :icon="'telephoneIcon'"
                        @click="openModalAskSpecialist()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes, { nullable, object } from 'vue-types';
import { setFavorite, isProductInFavorites } from '@/themes/novaporta/utils/favorites';
import { addProductToCart } from '@/themes/novaporta/utils/cart';
import { MODAL_ASK_SPECIALIST } from '~/themes/novaporta/consts/modals';

import viewport from '~/mixins/viewport';

export default {
    name: 'StalkingPanel',
    mixins: [viewport],
    props: {
        isActive: VueTypes.bool.isRequired,
        isAvailable: VueTypes.bool.isRequired,
        isPreloader: VueTypes.bool.isRequired,
        productId: VueTypes.number.isRequired,
        price: VueTypes.number.isRequired,
        phone: VueTypes.string.isRequired,
        services: VueTypes.arrayOf(Number).isRequired,
        activeExtensions: VueTypes.array.isRequired,
        extensionDirection: VueTypes.oneOfType([String, Object, nullable]).def(null),
        oldPrice: VueTypes.oneOfType([Number, nullable]).def(null),
        analyticProductData: VueTypes.any
    },
    data() {
        return {
            isInFavorites: false
        };
    },
    computed: {
        btnsSize() {
            return 'small';
        },
        isValidOldPrice() {
            return this.oldPrice > this.price ? true : false;
        },
        handledPrice() {
            let newPrice = this.price;

            this.activeExtensions.filter(ex => {
                const exPrice = ex?.price || 0;
                const exMultiplicity = ex?.multiplicity || 1;

                newPrice = newPrice + exPrice * exMultiplicity;
            });

            return newPrice;
        },
        handledOldPrice() {
            let newPrice = this.oldPrice;

            this.activeExtensions.filter(ex => {
                const exPrice = ex?.price || 0;
                const exMultiplicity = ex?.multiplicity || 1;

                newPrice = newPrice + exPrice * exMultiplicity;
            });

            return newPrice;
        }
    },
    components: {
        MyActionBtn: () => import('@/themes/novaporta/components/ui/MyActionBtn')
    },
    methods: {
        updateIsInFavorites() {
            if (isProductInFavorites(this.productId)) this.isInFavorites = true;
            else this.isInFavorites = false;
        },

        triggerActionFavorites() {
            // TO DO: add or remove from favorites list

            setFavorite(this?.analyticProductData?.product);
            this.updateIsInFavorites();
        },
        triggerActionAddToCart() {
            // TO DO: add or increase the count of product in cart

            addProductToCart(
                this.productId,
                this.services,
                1,
                this.activeExtensions,
                this.extensionDirection,
                this.$route.params.product,
                this?.analyticProductData?.product
            );

            this.$emit('open-add-to-cart');
        },
        setBodyPadding(flag) {
            document.body.classList[flag ? 'add' : 'remove']('--staking-panel-padding');
        },

        openModal(name) {
            this.$store.dispatch('global/open', name);
        },
        openModalAskSpecialist() {
            this.openModal(MODAL_ASK_SPECIALIST);
        }
    },
    beforeMount() {
        this.setBodyPadding(true);
    },
    beforeDestroy() {
        this.setBodyPadding(false);
    },
    mounted() {
        this.updateIsInFavorites();
    }
};
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
